/**
 * What a new password must contain, as the screens show it while a person types.
 * The backend decides (`_validate_password_strength` in the auth routes); this is
 * the same list, so a person sees why before they send.
 */
export interface PolicyCheck {
  label: string;
  test: (pw: string) => boolean;
}

export const PASSWORD_POLICY: PolicyCheck[] = [
  { label: 'At least 12 characters', test: (pw) => pw.length >= 12 },
  { label: 'One uppercase letter', test: (pw) => /[A-Z]/.test(pw) },
  { label: 'One lowercase letter', test: (pw) => /[a-z]/.test(pw) },
  { label: 'One digit', test: (pw) => /\d/.test(pw) },
  { label: 'One special character', test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

/** Which rules a password meets, in the order of the list. */
export function policyPasses(password: string): boolean[] {
  return PASSWORD_POLICY.map((rule) => rule.test(password));
}
